








import { Component, Vue, Prop } from 'vue-property-decorator';
import PopoutBulkAction from './PopoutBulkAction.vue';
import GenericBulkAction from './GenericBulkAction.vue';

@Component<MiDataTableBulkAction>({
  components: {
    PopoutBulkAction,
    GenericBulkAction,
  },
})
export default class MiDataTableBulkAction extends Vue {
  @Prop({ default: '' })
  protected icon!: string;

  @Prop({ default: '' })
  protected tooltip!: string;
}
